export default __webpack_public_path__ + "static/media/contact-center-abstract-concept_335657-3032.7c5c73b3.jpg";